export default {
  fr_be_at: require('./fr_be_at').default,
  by_ua: require('./by_ua').default,
  ge_mx_id: require('./ge_mx_id').default,
}



// WEBPACK FOOTER //
// ./src/content/biznisnet2020/data/presentations/index.js